import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import TextField from '@gef-ui/form-material/TextField';
import { getLabelMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { campaignTypes } from 'constants/campaigns';
import { MaxLengths } from 'constants/forms';
import { FIELDS } from 'features/views/campaignSettings/campaignDetail/form';
import { currencyViewParser } from 'utils/formats';

export const Parameters = ({ campaignType }) => (
	<Paper sx={{ p: 3, borderRadius: 2 }}>
		<Stack spacing={2}>
			<SectionHeader text={getLabelMessage('campaign:parametersTitle')} />
			<Grid container>
				<Grid size={12}>
					<Grid container spacing={2}>
						{campaignType === campaignTypes.UP_SELL && (
							<>
								<Grid size={4}>
									<TextField
										size="small"
										fieldName={FIELDS.expectedReplacement}
										label={getLabelMessage('campaign:expectedReplacement')}
										slotProps={{
											htmlInput: {
												maxLength: MaxLengths.PERCENTAGE,
											},
										}}
									/>
								</Grid>
								<Grid size={4}>
									<TextField
										size="small"
										fieldName={FIELDS.productionPlan}
										label={getLabelMessage('campaign:productionPlan')}
										viewParser={currencyViewParser}
										slotProps={{
											htmlInput: {
												maxLength: MaxLengths.PRODUCTION_PLAN,
											},
										}}
									/>
								</Grid>
							</>
						)}
						{campaignType === campaignTypes.X_SELL && (
							<Grid size={4}>
								<TextField
									size="small"
									fieldName={FIELDS.expectedValue}
									label={getLabelMessage('campaign:expectedValue')}
									viewParser={currencyViewParser}
									slotProps={{
										htmlInput: {
											maxLength: MaxLengths.EXPECTED_VALUE,
										},
									}}
								/>
							</Grid>
						)}
					</Grid>
				</Grid>
			</Grid>
		</Stack>
	</Paper>
);

Parameters.propTypes = {
	campaignType: PropTypes.number,
};

export default Parameters;
